import React from "react";
import { Row, Col, Form, Select, Input, Button } from "antd";
import { BIND_STATUS_OPTIONS, INSTALL_STATUS_OPTIONS } from "@/constants/util";

const Option = Select.Option;

const Search = (props) => {
  const { form, onAdd = () => {}, onSearch = () => {},onUpdate=()=>{},selectedRowKeys=[] } = props;

  const handleSubmit = () => {
    form.validateFields((err, values) => {
      if (!err) {
        onSearch(values);
      }
    });
  };

  return (
    <div className="searchTitle">
      <Row>
        <Col span={20}>
          <Form layout="inline">
            <Form.Item>
              {form.getFieldDecorator(
                "capsuleNo",
                {}
              )(
                <Input
                  style={{ width: 180 }}
                  placeholder="设备编号"
                  allowClear
                />
              )}
            </Form.Item>
            <Form.Item>
              {form.getFieldDecorator(
                "companyName",
                {}
              )(
                <Input style={{ width: 180 }} placeholder="运营商" allowClear />
              )}
            </Form.Item>
            <Form.Item>
              {form.getFieldDecorator(
                "bindState",
                {}
              )(
                <Select
                  style={{ width: 180 }}
                  placeholder="绑定状态"
                  allowClear={true}
                >
                  {BIND_STATUS_OPTIONS.map((option) => (
                    <Option key={option.value} value={option.value}>
                      {option.label}
                    </Option>
                  ))}
                </Select>
              )}
            </Form.Item>
            <Form.Item>
              {form.getFieldDecorator(
                "status",
                {}
              )(
                <Select
                  style={{ width: 180 }}
                  placeholder="安装状态"
                  allowClear={true}
                >
                  {INSTALL_STATUS_OPTIONS.map((option) => (
                    <Option key={option.value} value={option.value}>
                      {option.label}
                    </Option>
                  ))}
                </Select>
              )}
            </Form.Item>
            <Form.Item>
              <Button type="primary" onClick={handleSubmit}>
                搜索
              </Button>
            </Form.Item>
          </Form>
        </Col>
        <Col span={4} align="right">
          <Button type="primary" onClick={onUpdate} style={{marginRight:16}} disabled={selectedRowKeys.length==0}>
            更新
          </Button>
          <Button type="primary" onClick={onAdd}>
            新增设备
          </Button>
        </Col>
      </Row>
    </div>
  );
};

export default Form.create()(Search);
